module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropDown),
      expression: "closeDropDown"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpen
    },
    on: {
      "click": _vm.toggleDropDown
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle btn-rotate",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)"
    }
  }, [_vm._t("title", [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('p', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.title) + "\n        "), _c('b', {
    staticClass: "caret"
  })])])], 2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f7d1404!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Dropdown.vue
// module id = 168
// module chunks = 2